module.exports = __webpack_public_path__ + "media/images/front/icons/alert-4dbd3b724a083f6ca79726e629a5c476.svg";